module.exports = __webpack_public_path__ + "media/Beep2.e6358714.wav";